import React, { useState } from 'react';
import PropTypes from 'prop-types';
import api from '../../api/client';
import { Button } from '../common';
import { TODO_STATUS } from '../../constants';

/**
 * EditTodoStatusModal - Quick status update for tasks
 */
const EditTodoStatusModal = ({ todo, onClose, onSave }) => {
  const [status, setStatus] = useState(todo?.status || TODO_STATUS.NOT_STARTED);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const handleSave = async () => {
    setSaving(true);
    try {
      await api.patch(`/todos/${todo.id}/status`, { status });
      onSave();
    } catch (error) {
      console.error('Failed to update status:', error);
      setError('Failed to update status');
    } finally {
      setSaving(false);
    }
  };

  if (!todo) return null;

  return (
    <div className="modal-overlay">
      <div className="modal">
        <div className="modal-header">
          <h2 className="modal-title">Edit Task Status</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>
        <div className="modal-body">
          {error && <div className="alert alert-error">{error}</div>}
          <div className="form-group">
            <label className="form-label">Status</label>
            <select
              className="form-input"
              value={status}
              onChange={(e) => setStatus(e.target.value)}
            >
              <option value={TODO_STATUS.NOT_STARTED}>{TODO_STATUS.NOT_STARTED}</option>
              <option value={TODO_STATUS.IN_PROGRESS}>{TODO_STATUS.IN_PROGRESS}</option>
              <option value={TODO_STATUS.DONE}>{TODO_STATUS.DONE}</option>
            </select>
          </div>
        </div>
        <div className="modal-footer">
          <Button variant="secondary" onClick={onClose} disabled={saving}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSave} disabled={saving}>
            {saving ? 'Saving...' : 'Save'}
          </Button>
        </div>
      </div>
    </div>
  );
};

EditTodoStatusModal.propTypes = {
  todo: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

export default EditTodoStatusModal;
